import { Carousel } from "antd";
import { format } from "date-fns";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import LeftSideWrapperDB from "../../components/dashboard/left-side-wrapper";
import RecommendationsNadNextSteps from "../../components/dashboard/Recommendations-next-steps";
import { en } from "../../components/dashboard/Recommendations-next-steps/content";
import { es } from "../../components/dashboard/Recommendations-next-steps/es";
import { fr } from "../../components/dashboard/Recommendations-next-steps/fr";
import { hi } from "../../components/dashboard/Recommendations-next-steps/hi";
import RightSideWrapperDB from "../../components/dashboard/right-sde-wrapper";
import BudgetInsights from "../../components/dashboard/right-sde-wrapper/BudgetInsights";
import {
  fetchExchangeRates,
  getDashboardDetails,
} from "../../controller/services/dashboard";
import { getSponsors } from "../../controller/services/settings";
import i18n from "../../localization/i18n";
import { setLoading } from "../../redux/slices/common_slice";
import { setExchangeRates } from "../../redux/slices/currency_slice";
import {
  setDashboardData,
  setSelectedMonth,
} from "../../redux/slices/dashboard_slice";
import { routePaths } from "../../routing/routePaths";
import {
  convertCurrency,
  getCurrentMonthYear,
  reorderCurrencies,
} from "../../utils/helper";

const Dashboard = () => {
  const locationData = useLocation();
  const [sponsors, setSponsors] = useState([]);
  const isMobile = window?.innerWidth < 768;
  const containerRef = useRef();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const type = useSelector((state) => state.dashboard.type);
  const dashboardPayload = { month: getCurrentMonthYear(), type: "all" };
  const dashboardData = useSelector((state) => state.dashboard.dashboardData);
  const currencySelected = useSelector(
    (state) => state.currency.currencySelected
  );
  const exchangeRates = useSelector((state) => state.currency.exchangeRates);
  const amount =
    convertCurrency(
      dashboardData?.remainBudget,
      exchangeRates,
      currencySelected
    ) || 0;
  const surplusOrDeficit = amount >= 0 ? "Surplus" : "Deficit";
  const getScenario = () => {
    const contentJson =
      i18n.language === "hi"
        ? hi
        : i18n.language === "fr"
        ? fr
        : i18n.language === "es"
        ? es
        : en;
    if (surplusOrDeficit === "Surplus") {
      if (dashboardData?.expense?.debtDetails?.length > 0 && amount <= 500) {
        return contentJson?.case1;
      } else if (
        dashboardData?.expense?.debtDetails?.length > 0 &&
        amount >= 500
      ) {
        return contentJson?.case2;
      } else if (
        dashboardData?.expense?.debtDetails?.length === 0 &&
        amount <= 500
      ) {
        return contentJson?.case3;
      } else if (
        dashboardData?.expense?.debtDetails?.length === 0 &&
        amount >= 500
      ) {
        return contentJson?.case4;
      }
    } else {
      if (
        dashboardData?.expense?.debtDetails?.length > 0 &&
        Math.abs(amount) <= 500
      ) {
        return contentJson?.case5;
      } else if (
        dashboardData?.expense?.debtDetails?.length > 0 &&
        Math.abs(amount) >= 500
      ) {
        return contentJson?.case6;
      } else if (
        dashboardData?.expense?.debtDetails?.length === 0 &&
        Math.abs(amount) <= 500
      ) {
        return contentJson?.case7;
      } else if (
        dashboardData?.expense?.debtDetails?.length === 0 &&
        Math.abs(amount) >= 500
      ) {
        return contentJson?.case8;
      }
    }
  };

  useEffect(() => {
    if (containerRef) {
      containerRef.current.scrollTo({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
      window.scrollTo({ top: 0 });
    }
  }, [containerRef]);

  useEffect(() => {
    if (locationData?.state?.budgetData?._id) {
      dispatch(setDashboardData(locationData?.state?.budgetData));
      fetchExchangeNsponsors();
    } else {
      fetchDashboardData();
    }
  }, [locationData?.state?.budgetData?._id]);
  const fetchDashboardData = () => {
    dispatch(setLoading(true));
    Promise.all([
      fetchExchangeRates(),
      getSponsors(),
      getDashboardDetails(dashboardPayload),
    ])
      .then(([ratesRes, sponsorsRes, dashboardRes]) => {
        dispatch(setDashboardData(dashboardRes?.data));
        dispatch(setSelectedMonth(format(new Date(), "MM-yyyy")));
        const reorderedCurrency = reorderCurrencies(ratesRes?.rates);
        dispatch(setExchangeRates(reorderedCurrency));
        if (sponsorsRes.data.sponsor?.length > 0) {
          const chunkSize = isMobile ? 2 : 3;
          const result = [];

          for (let i = 0; i < sponsorsRes.data.sponsor.length; i += chunkSize) {
            result.push(sponsorsRes.data.sponsor.slice(i, i + chunkSize));
          }
          setSponsors(result);
        }
      })
      .catch((err) => {
        console.error(err?.message);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

  const fetchExchangeNsponsors = () => {
    dispatch(setLoading(true));
    Promise.all([fetchExchangeRates(), getSponsors()])
      .then(([ratesRes, sponsorsRes]) => {
        const reorderedCurrency = reorderCurrencies(ratesRes?.rates);
        dispatch(setExchangeRates(reorderedCurrency));
        if (sponsorsRes.data.sponsor?.length > 0) {
          const chunkSize = isMobile ? 2 : 3;
          const result = [];

          for (let i = 0; i < sponsorsRes.data.sponsor.length; i += chunkSize) {
            result.push(sponsorsRes.data.sponsor.slice(i, i + chunkSize));
          }
          setSponsors(result);
        }
      })
      .catch((err) => {
        console.error(err?.message);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

  return (
    <>
      <div
        className="container-fluid bg-common dashboard-common dashboard-main-fluid"
        ref={containerRef}
        style={{
          ...(locationData?.state?.budgetData?._id && { padding: "25px 15px" }),
          ...(window.innerWidth < 768 &&
            i18n.language === "hi" && { padding: "385px 0 20px" }),
          ...(window.innerWidth < 768 &&
            i18n.language === "fr" && { padding: "425px 0 20px" }),
          ...(window.innerWidth < 768 &&
            i18n.language === "es" && { padding: "435px 0 20px" }),
          ...(window.innerWidth < 768 &&
            i18n.language === "en" && { padding: "415px 0 20px" }),
        }}
      >
        <div className="container">
          <div className="row dashboard-main-row">
            <div className="col-12">
              {locationData?.state?.budgetData?._id && (
                <div className="col-12 back-arrow-div mb-3">
                  <Link
                    className="d-flex align-items-center"
                    to={routePaths.dashboard}
                  >
                    <img
                      src="/assets/images/icons/back-arrow-icon.png"
                      className="img-fluid"
                      alt=""
                    />
                    {t("dashboard.backBtn")}
                  </Link>
                </div>
              )}
              <div className="row">
                <div className="col-12 mobile-p-0">
                  <LeftSideWrapperDB surplusOrDeficit={surplusOrDeficit} />
                  <RightSideWrapperDB />
                </div>
              </div>
              {(dashboardData?.totalIncome != 0 ||
                dashboardData?.totalExpense != 0) && (
                <div className="row recommendations-and-next-steps">
                  <div className="col-12">
                    {type === "all" && <BudgetInsights />}
                    <h2>{t("dashboard.recommendationTitle")}</h2>
                    <p>{getScenario()?.title}</p>
                  </div>
                  <div className="col-12">
                    <RecommendationsNadNextSteps
                      children={getScenario()?.children}
                    />
                  </div>
                </div>
              )}
              {false && (
              <div className="row recommendations-and-next-steps sponsers-partner-row">
                <div className="col-12 col-sm-12 col-md-12 col-xl-12 col-lg-12">
                  <div className="row">
                    <div className="col-12">
                      <h2>{t("dashboard.ourPartners")}</h2>
                      <div className="row">
                        <Carousel
                          autoplay
                          arrows
                          vertical={false}
                          nextArrow={
                            <img
                              alt=""
                              className="img-fluid"
                              src="/assets/images/icons/line-arrow-black-slider.svg"
                            />
                          }
                          prevArrow={
                            <img
                              alt=""
                              className="img-fluid"
                              src="/assets/images/icons/left-line-arrow-slider.svg"
                            />
                          }
                        >
                          {sponsors?.map((item, idx) => {
                            return (
                              <div key={`sponsor-${idx}`}>
                                <div className="row justify-content-center">
                                  {item?.map((sponsor) => (
                                    <ul className="list-inline text-center" key={sponsor?._id}>
                                      <li className="list-inline-item">
                                        <a
                                          href={sponsor?.link}
                                          key={sponsor?._id}
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          <div className="row mx-0 recommendations-card">
                                            <div className="col-12 text-center ">
                                              <img
                                                src={sponsor?.logo}
                                                alt=""
                                                className="img-fluid"
                                              />
                                            </div>
                                          </div>
                                        </a>
                                      </li>
                                    </ul>
                                  ))}
                                </div>
                              </div>
                            );
                          })}
                        </Carousel>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
